import styled from 'styled-components';

export const StyledStockList = styled.section`
	padding: 120px 0 120px;
	position: relative;
	z-index: 3;
	.dc-btn-link {
		height: 25px;

		a {
			font-weight: 500;
			font-size: 1.25rem; /* 20px */
			line-height: 1.5rem; /* 24px */
			letter-spacing: 0;

			span {
				text-decoration: underline;
			}
		}
	}

	.stock-list {
		margin-top: 80px;
		.single-item {
			&:last-child {
				.stock-single {
					border-bottom: none;
					padding-bottom: 0;
					margin-bottom: 0;
				}
			}
		}
	}

	@media (max-width: 767px) {
		.filter {
			.col-md-3 {
				margin-bottom: 20px;
			}
		}
	}
`;
